export default (params) => ({
  trigger: {
    name: 'filter_and_sort.confirm_price_filter',
    params: params,
  },
  config: {
    schema: {
      filter_value: {
        type: 'string',
      },
      number_of_items: {
        type: 'integer',
      },
      is_recommended: {
        type: 'boolean',
      },
      sub_feature: {
        enum: [
          'filter_and_sort_overlay',
          'filter_list',
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'select_filter',
      params: {
        filter_name: 'price_range_input_field',
      },
    },
  },
});
